export default __webpack_public_path__ + "static/media/HyperTubePole.256.5d2b2e5e.png";